import { useState, useEffect } from "react";
import Navbar from "./components/Navbar/Navbar";
import Home from "./pages/Home";

import { urls } from "../src/adresses";

function App() {
  const [inputValue, setInputValue] = useState("");
  const [userData, setUserData] = useState(null);
  const [leagueData, setLeagueData] = useState([]);
  const [matches, setMatches] = useState([]);
  const [game, setGame] = useState([]);
  const [championsList, setChampionsList] = useState([]);
  const [summoners, setSummoners] = useState([]);
  const [queueId, setQueueId] = useState([]);

  useEffect(() => {
    // Şampiyonların API'ını al ve state'e kaydet
    (() => {
      fetch(`${urls.GET_CHAMPİONS}`)
        .then(response => response.json())
        .then(response => setChampionsList(response.data));
    })();

    // Summonerların API'ını al state'e kaydet
    (() => {
      fetch(
        "https://ddragon.leagueoflegends.com/cdn/11.2.1/data/en_US/summoner.json"
      )
        .then(response => response.json())
        .then(data => setSummoners(data.data));
    })();

    (() => {
      fetch(
        "https://static.developer.riotgames.com/docs/lol/queues.json"
      )
        .then(response => response.json())
        .then(data => {
          setQueueId(data);
        });
    })();
  }, []);

  useEffect(() => {
    if (userData) {
      // Kullanıcının ID'sine Göre Kümesini Al
      (async () => {
        await fetch(
          // `${urls.GET_TIER_BY_ID}/${userData.id}?api_key=${API_KEY}`
          `https://apiofopgg.herokuapp.com/get-tier/${userData.id}`
        )
          .then(response => response.json())
          .then(data => {
            // console.log(data);
            setLeagueData([...data].reverse());
          });
      })();
      // Kullanıcının Maçlarını AccountId'ye Göre Al
      (async () => {
        await fetch(
          // `${urls.GET_MATCHES_BY_ACC_ID}/${userData.accountId}?api_key=${API_KEY}`
          `https://apiofopgg.herokuapp.com/get-matches/${userData.accountId}`
        )
          .then(response => response.json())
          .then(matchData => {
            // console.log(matchData.matches.slice(0, 7));
            setMatches(matchData.matches.slice(0, 7));
          });
      })();

      // console.log(userData.accountId);
    }
  }, [userData]);

  return (
    <>
      <Navbar
        inputValue={inputValue}
        setInputValue={setInputValue}
        setUserData={setUserData}
      />
      <Home
        userData={userData}
        leagueData={leagueData}
        matches={matches}
        game={game}
        queueId={queueId}
        summoners={summoners}
        championsList={championsList}
      />
    </>
  );
}

export default App;
